import { TableCell } from "@/components/ui/table"
import { Badge } from "@/components/ui/badge"
import { HelpCircle } from "lucide-react"
import { PROPERTY_TYPE_CONFIG, formatSurface } from "@/lib/project-configs"
import type { Project } from "@/types"

export function PropertyTypeCell({ project }: { project: Project }) {
  const ptCfg = PROPERTY_TYPE_CONFIG[project.property_type]
  const PtIcon = ptCfg?.icon || HelpCircle

  return (
    <TableCell>
      <div className="flex flex-col gap-0.5">
        <Badge variant="outline" className="w-fit gap-1.5">
          <PtIcon className="size-3.5" />
          {ptCfg?.label || project.property_type}
        </Badge>
        {(project.field_surface != null || project.house_surface != null) && (
          <span className="text-muted-foreground text-xs">
            {[formatSurface("Terrain", project.field_surface), formatSurface("Bâti", project.house_surface)]
              .filter(Boolean)
              .join(" · ")}
          </span>
        )}
      </div>
    </TableCell>
  )
}
